module.exports = "<div class=\"row\" ng-init=\"entityManageCtrl.init()\">\n\t<div class=\"col-md-12\">\n\t\t<h1 class=\"page-header\">Entity Management <small>Dynamic Entity Configuration</small></h1>\n\t</div>\n\n\t<div class=\"col-md-3\">\n\t\t<sn-entity-list selected-entity=\"entityManageCtrl.selectedEntity\"></sn-entity-list>\n\t</div>\n\t<div class=\"col-md-9\">\n\t\t<sn-entity-property-list selected-entity=\"entityManageCtrl.selectedEntity\"></sn-entity-property-list>\n\t\t<sn-entity-rule-list selected-entity=\"entityManageCtrl.selectedEntity\"></sn-entity-rule-list>\n\t</div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/platform/templates/entity/entity-manage.html
 ** module id = 153
 ** module chunks = 0
 **/